// extracted by mini-css-extract-plugin
export default {"container":"BlogPage_container__-lcLB","card":"BlogPage_card__8TpDu","img":"BlogPage_img__Q6s3v"};